import type { FaireProductEntity } from "../../entity_types/product";

export const p_m89y6rna2x: FaireProductEntity = {
  token: "p_m89y6rna2x",
  type: "product",
  name: "Stars Reversible Sweater Knit Baby Blankets Organic Cotton",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/e120e12bc7085841f3b09ae8c2573e2e0c28a11277296ec2fa7bd0f529b3074d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/260696c8803a9e1d99110f43b97e58fa162520b08fb45c7ea46bd6d9aac3d699.png",
    "https://cdn.faire.com/fastly/f4f55129b036f1fac9c9c8417af29289f5807d33fe0ed7c2236ef08bd5a8f3e4.jpeg",
    "https://cdn.faire.com/fastly/d7f921eb5c595827a8b2a9d76d0754caf1536df3c0bef8a0f6c64993673be315.jpeg",
    "https://cdn.faire.com/fastly/eeb57f5c951f7c8935a4b5028d4fd9e4691902bd16ef66290133db8c43cacca8.png",
    "https://cdn.faire.com/fastly/1966335bc86c983795df62c58055df5c5bb84ce876c94d10f9160eb68ff798a8.png",
    "https://cdn.faire.com/fastly/609318bb6368ca4be8e005a5094d2133d9e04c41acd9865f1b007c7d39c46361.jpeg",
    "https://cdn.faire.com/fastly/0943ebff1aa243c4f0cd3c842951aa56cb518081dd5d710f55e5d12539683802.png",
    "https://cdn.faire.com/fastly/10cbe5bb2385707a99070a3f8e82b1f04f6e6b51d729f3f4e82ef697e077ea1c.png",
    "https://cdn.faire.com/fastly/145a25399947ff0c5a92f1b5175ddcd2b11a197bde276824f0ad95d7303aeaa8.jpeg",
    "https://cdn.faire.com/fastly/6f4345181d682bcf6ae118bc839ce0f4bf2bc6b0780697f2709dfaaca81d1a3b.jpeg",
    "https://cdn.faire.com/fastly/96072533429faa5672b82665883495c0ff0914c7355bc91cfa3cfc2ffabdf9d6.jpeg",
    "https://cdn.faire.com/fastly/c26bf07d0fed7b45dea9cd7f1326c48644ebd0f00f1521bece1371aaa84d46e7.jpeg",
    "https://cdn.faire.com/fastly/c6e8d6b5b4e27119f4929727d45b6d15b8852745e9db65882b5e31d7efb309dd.jpeg",
    "https://cdn.faire.com/fastly/591ed0bbcec05add1182f505da77a000c5d18ad6cf94b71f1cd6487655ce4858.jpeg",
    "https://cdn.faire.com/fastly/ed83a885b83fc57313a06a13eda7fb649e956001a1e0f904cc62aa0883b73427.jpeg",
  ],
  priceDollars: 26,
  description:
    "Luxurious 100% Organic Cotton Jacquard Knitted Baby Blanket\nWrap your little one in pure comfort with our elegant organic cotton sweater knit baby blanket—a timeless addition to any nursery.\n\nPerfect Size: Generously sized at 30x42”, ideal for cribs, strollers, and snuggle time.\nAll-Season Comfort: Ultra-soft, lightweight, breathable, and cozy—designed to keep your baby comfortable year-round.\nSafe & Gentle: Made with non-toxic, natural fabrication, perfect for sensitive skin. Crafted using eco-friendly and sustainable materials.\nEthically Made: Conscientiously designed in the USA and ethically produced by skilled artisans at a GOTS-certified facility in India.\nSustainably Sourced: Made from organic cotton grown by smallholder farmers, supporting better livelihoods and sustainable farming practices.\nExperience the luxurious softness and thoughtful design of Viverano—a family-owned small business dedicated to creating products that nurture your baby while caring for the planet.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T05:03:44.984Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
